import React from 'react'
import { Link } from 'react-router-dom'
import wad from '../../../../assets/img/mad_mn.webp'
import './Wadhead.css'
import ContactForm from '../../Contact/ContactForm'

function Wadhead() {
  return (
    <section className='hmslder-sec serhead-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li><Link to='/Service'>Services</Link></li>  
               <li>Mobile Application Development</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Leading <span>Mobile Application Development</span> Company</h2>
              <p>With over 11 years of experience in Android, iOS, and web mobile app development, 360-Bytes stands out as a top-rated company in the GCC. Partner with our expert developers to achieve seamless digital transformation and stay ahead in the competitive market.</p>
              <p></p>
            </div> 
                         <ContactForm/>
           {/* <div className='hmslder-img'>
            <img src={wad} alt='Mobile Application Development' width={1200} height={800} loading="lazy" />
            </div>   */}
        </div>
    </section>
  )
}

export default Wadhead
